import { render, staticRenderFns } from "./newNotice.vue?vue&type=template&id=4b7d905d&"
import script from "./newNotice.vue?vue&type=script&lang=js&"
export * from "./newNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VRow})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b7d905d')) {
      api.createRecord('4b7d905d', component.options)
    } else {
      api.reload('4b7d905d', component.options)
    }
    module.hot.accept("./newNotice.vue?vue&type=template&id=4b7d905d&", function () {
      api.rerender('4b7d905d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/CustomForm/CustomForm/components/newNotice.vue"
export default component.exports